import { cn } from "@/shared/lib/cn";
import { Alert } from "../core/Alert/Alert";

export interface FormErrorProps {
  /** El mensaje, o `null` cuando no hay nada que contar. */
  error: string | null;
  onDismiss?: () => void;
  className?: string;
}

/**
 * El aviso de lo que falló SIN ser culpa de un campo concreto: credenciales
 * que no cuadran, el servidor caído, demasiados intentos.
 *
 * Va FUERA del `<Form>` a propósito. Dentro heredaría el `gap` de la
 * rejilla del formulario y quedaría separado el doble; y conceptualmente
 * no es un campo: es el resultado del último envío.
 *
 * Se pinta a sí mismo o nada, así que las pantallas dejan de escribir el
 * `{formError && (...)}` que repetían idéntico.
 */
export function FormError({ error, onDismiss, className }: FormErrorProps) {
  if (!error) return null;

  return (
    <Alert variant="error" className={cn("mb-4", className)} onDismiss={onDismiss}>
      {error}
    </Alert>
  );
}
